<template>
    <div id="app-body" class="body" style="min-height: 100vh;">
        <!-- Modale Redirect (Refactored) -->
        <Dialog 
            v-model="showRedirectDialog" 
            :title="$t('components.socialLogin.modale.errore.titolo')"
            persistent
            :show-close="false"
        >
            <p id="modal-redirect-message-body"></p>
            <template #footer>
                <Button 
                    :label="$t('generale.ok')" 
                    @click="redirectStore()"
                />
            </template>
        </Dialog>

        <NotificationToast ref="toast" />

        <div id="app" v-if="initialized && !mobileStatus" v-cloak>
            <transition name="page-fade" mode="out-in">
                <router-view/>
            </transition>
        </div>

    </div>
</template>

<script>
import AppSingleton from './helpers/AppSingleton';
import 'bootstrap';
import $ from "jquery";
import { mapActions } from 'vuex';
import { NOTIFICATIONS_ACTIONS } from "@/store/notifications/actions-enum";
import {routesEnums, themeEnums} from "@/helpers/enums";
import {mobileCheck} from "@/lib/mobileCheck";
import {
  mobileAllowedRoutes,
  mobileIosAndAndroidAllowedRoutes,
  MobileRedirectedRoutes,
  UrlGoToFallback,
  VerifyRoutes
} from "./config";

import { AUTH_GETTERS } from "@/store/auth/getters-enum";
import { MODULES } from "@/store/modules-enum";

import { logEvent } from "firebase/analytics";
import { analytics } from "@/firebase";

import {Storage} from "./helpers/enums";
import './assets/css/tailwind.css';
import { messaging } from './firebase';
import { onMessage } from "firebase/messaging";
import NotificationToast from "@/components/NotificationToast";
import Dialog from "@/components/common/Dialog";
import Button from "@/components/common/Button";


export default {
    name: "App",
    components: {
      NotificationToast,
      Dialog,
      Button
    },
    data() {
        return {
            initialized: false,
            mobileStatus: undefined,
            showRedirectDialog: false,
        }
    },
    mounted() {
        //console.log('init')
        this.verifyTLSVersion();
        this.setDefaultTheme();


        const notificationChannel = new BroadcastChannel("notifications-channel");

        onMessage(messaging, (payload) => {
          
          if (payload.notification) {
             // Recuperiamo l'ID utente corrente dallo store
            const profile = this.$store.getters[`${MODULES.AUTH}/${AUTH_GETTERS.PROFILE}`];
            const userId = profile ? profile.id_utente_concorsando : 'anonymous';

            // Costruiamo un oggetto notifica completo da salvare
            const fullNotification = {
              id: payload.messageId || (Date.now() + Math.random().toString(36).substr(2, 9)),
              title: payload.notification.title,
              body: payload.notification.body,
              type: payload.data.type,
              userId: userId,
              timestamp: new Date().toISOString(),
              read: false,
              data: payload.data || {}
            };

            // 1. Aggiunge allo store (che a sua volta salva in IndexedDB grazie alla mutation)
            this[NOTIFICATIONS_ACTIONS.PUSH_NOTIFICATION](fullNotification);
            
            // 2. Mostra il Toast
            this.$refs.toast.display(fullNotification);

            // 3. Notifica le altre schede aperte
            notificationChannel.postMessage({
              type: "NEW_FOREGROUND_NOTIFICATION",
              payload: fullNotification,
            });
          }
        });

        // Ascolta le notifiche ricevute dal Service Worker quando l'app è in background
        // o da altre schede quando l'app è in primo piano
        notificationChannel.onmessage = (event) => {
          if (event.data && (event.data.type === "NEW_BACKGROUND_NOTIFICATION" || event.data.type === "NEW_FOREGROUND_NOTIFICATION")) {
            const incomingNotification = event.data.payload;
            
            // Recuperiamo l'ID utente corrente
            const profile = this.$store.getters[`${MODULES.AUTH}/${AUTH_GETTERS.PROFILE}`];
            const currentUserId = profile ? String(profile.id_utente_concorsando) : 'anonymous';

            // Verifichiamo che la notifica sia per l'utente loggato (o per tutti se anonymous)
            if (String(incomingNotification.userId) === currentUserId || incomingNotification.userId === 'anonymous') {
              // Aggiunge allo store Vuex (la mutation gestisce già i duplicati tramite ID)
              this[NOTIFICATIONS_ACTIONS.PUSH_NOTIFICATION](incomingNotification);
              
              // Se è una notifica in primo piano da un'altra scheda, potremmo voler mostrare il toast?
              // Per ora seguiamo la richiesta di aggiornare solo il numero (tramite store).
            }
          }
        };

        AppSingleton.setInstance(this);

        // Call onRouterReady only when the route is loaded
        const unwatch = this.$watch(
            () => this.$route,
            (route) => {
                if (route.name != null) {
                    this.onRouterReady(() => unwatch());
                }
            }
        )
        if (this.$route.name != null) {
            this.onRouterReady(() => unwatch());
        }
    },
    methods: {
        ...mapActions('ui', ['closeMobileSidebar']), // Map the action
        onRouterReady(done = () => {        }) {
            const isMobile = mobileCheck()
            /*
            const isMobileAllowed = isMobile?.type !== 'isMobileAgiHMS' ?  mobileIosAndAndroidAllowedRoutes.includes(this.$route.name) :  mobileAllowedRoutes.includes(this.$route.name);
            const isFallback = this.verifyFallback();
            //gestione rotte autorizzate per fallback mobile
            if(isMobile && isMobile?.type !== 'isMobileAgiHMS' && isFallback){
             this.goToFallback(isMobile, done)
           } else if (isMobile && !isMobileAllowed) {
                this.mobileStatus = isMobile;
                this.showRedirectDialog = true;
                this.$nextTick(() => {
                    $('#modal-redirect-message-body').html(isMobile.msg)
                })
            } else { 
              this.verifyDeepLink();
              this.init(isMobile, done)
            } 
            */
            this.verifyDeepLink();
            this.init(isMobile, done)
        },
        init(isMobile, done){
          if (!this.initialized) {
            this.initialized = true
            let recaptchaScript = document.createElement('script')
            recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit')
            recaptchaScript.async = true
            document.head.appendChild(recaptchaScript)
          }
          if (!isMobile) {
            done();
          }
        },
        verifyDeepLink() {
          if (this.$route.query.notification_type === '3') {
             this.$router.push({ name: routesEnums.CALL });
             return;
          }
          switch (this.$route.path) {
            case UrlGoToFallback.AUTH:
              break;
            case UrlGoToFallback.DOWNLOAD_DATA:
              if (this.$route?.query?.id_concorso) {
                sessionStorage.setItem(Storage.DOWNLOAD_DATA_ID_CONCORSO, this.$route?.query?.id_concorso)
              }
              if (this.$route?.query?.id_argomento) {
                sessionStorage.setItem(Storage.DOWNLOAD_DATA_ID_ARGOMENTO, this.$route?.query?.id_argomento)
              }
              this.$router.push({name: routesEnums.HOME})
              break;
          }
         },
        goToFallback(isMobile, done) {
          if (this.$route.name !== routesEnums.FALLBACK) {
            this.$router.push({name: routesEnums.FALLBACK, params: {link: location.href}})
          }
          this.init(isMobile, done)
        },
        verifyFallback(){
          let isFallback = false;
          switch (this.$route.path) {
            case UrlGoToFallback.AUTH:
              isFallback = this.$route?.query?.code && this.$route?.query?.type && this.$route?.query?.urifefid;
              break;
            case UrlGoToFallback.DOWNLOAD_DATA:
              isFallback = this.$route?.query?.id_concorso || this.$route?.query?.id_argomento;
              break;
          }
          return isFallback
        },
        setDefaultTheme() {
            if (localStorage.getItem('theme') === themeEnums.DARK) {
                $('html').addClass('theme-dark');
                $('body').addClass('theme-dark');
            } else {
                $('html').addClass('theme-light');
                $('body').addClass('theme-light');
            }
        },
        redirectStore() {
            const redirect_url = this.mobileStatus && this.mobileStatus.redirect_url;
            if (redirect_url) {
                window.location.replace(redirect_url);
            }
        },
        ...mapActions(MODULES.NOTIFICATIONS, [NOTIFICATIONS_ACTIONS.PUSH_NOTIFICATION]),
        verifyTLSVersion() {
            fetch('https://www.howsmyssl.com/a/check')
                .then(response => response.text())
                .then(body => {
                    let json;
                    try {
                        json = JSON.parse(body)
                    } catch (e) {
                        return console.error(json);
                    }

                    if (json && json.tls_version) {
                       if (analytics) {
                            logEvent(analytics, 'web_tls_version', {
                                tls_version: json.tls_version.toUpperCase()
                            });
                        }
                        window.fbq('trackCustom', 'web_tls_version', {tls_version: json.tls_version.toUpperCase()
                        })
                    }

                })
                .catch(error => {
                    console.error('Error verifying TLS version:', error);
                });
        },
    }
}
</script>

<style lang="scss">
@import 'assets/css/bootstrap.scss';
</style>
<style lang="css">
@import 'assets/css/icons.min.css';
</style>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;600;700&display=swap');

@import 'assets/css/app.scss';
@import 'assets/css/style.scss';

body, html {
  font-family: 'Nunito', sans-serif !important;
}

.page-fade-enter-active, .page-fade-leave-active {
  transition: opacity 0.3s ease;
}
.page-fade-enter, .page-fade-leave-to {
  opacity: 0;
}



#chtl-open-chat-icon{
  margin-bottom: 4rem;
  margin-right: -1rem;
}

@media (min-width: 768px) {

    #chtl-open-chat-icon{
      margin: auto;
    }
}

/* 1. REGOLA GENERALE: Nascondi l'iframe ovunque sia */
#chtl-chat-iframe {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    pointer-events: none !important; /* Impedisce click se è invisibile ma presente */
}

/* 2. ECCEZIONE: Mostralo SOLO se è figlio di #tutor-ai-wrapper */
#tutor-ai-wrapper #chtl-chat-iframe {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    pointer-events: auto !important;
}
</style>
